import { CurrencyPipe, NgForOf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Payroll } from '@app/models/payroll/payroll.model';
import { PlatformModule } from '@app/platform.module';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-other-remittances-details',
    templateUrl: './other-remittances-details.template.html',
    standalone: true,
    imports: [PlatformModule, TranslateModule, NgForOf, CurrencyPipe],
})
export class OtherRemittancesDetailsComponent {
    @Input({ required: true }) payroll!: Payroll;
}
